import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../_redux/actions";
import { alertActions } from "../../../_redux/actions";
import DialogContent from "@material-ui/core/DialogContent";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import { utilFunctions } from "../../../_helpers";

const UserFactoryView = (props) => {
    const dispatch = useDispatch();
    const [factoryList, setFactoryList] = useState([])
    const userDetailState = useSelector((state: any) => state.users.userDetail);

    React.useEffect(() => {
        dispatch(userActions.getUserDetail(props.user.email,
            (res) => {
                setFactoryList(utilFunctions.formatUserFactories(res.userFactories));
            },
            (error) => {
                dispatch(alertActions.triggerAlert(true, error, 'error'))
            }))
    }, [props.user])

    return (
        <div>
            <DialogContent>
                <TableContainer component={Paper}>
                    <Table aria-label="simple table"  size="small" className={'appTable'}>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th">Plant Code</TableCell>
                                <TableCell component="th">Factory Code</TableCell>
                                <TableCell component="th">Factory Name</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {factoryList.map((row, index) => {
                                return (
                                    <TableRow key={row.factoryId}>
                                        <TableCell component="td">{row.plantCode}</TableCell>
                                        <TableCell component="td">{row.factoryCode}</TableCell>
                                        <TableCell component="td">{row.factoryName}</TableCell>
                                    </TableRow>
                                );
                            })}
                            {(!userDetailState.isLoading && factoryList.length == 0) ? <TableRow><TableCell colSpan={3}> No data found.</TableCell></TableRow> : null}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>

        </div>
    );
}

UserFactoryView.propTypes = {
    user: PropTypes.any,
    onClose: PropTypes.func,
}

export default UserFactoryView;
